import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {LocaleService} from '../../../shared/services/locale.service';
import {CompanyService} from '../../../shared/services/company.service';
import {empty} from '../../../functions';
import {ApiService} from '../../../shared/services/api.service';
import {alertMessages, AlertService} from '../../../shared/services/alert.service';
import {catchError} from 'rxjs/operators';
import {ImageCroppedEvent} from 'ngx-image-cropper';
import bsCustomFileInput from 'bs-custom-file-input';
import { BlockQuote, Bold, ClassicEditor, EditorConfig, Heading, Italic, Link, List, Table, TableToolbar } from 'ckeditor5';

@Component({
    selector: 'app-modal-company-profile-tradename',
    templateUrl: './modal-company-profile-tradename.component.html',
    styleUrls: ['./modal-company-profile-tradename.component.scss'],
    standalone: false
})
export class ModalCompanyProfileTradenameComponent implements OnInit {

  isProcessing = false;


  public Editor = ClassicEditor;
  public editorConfig: EditorConfig = {
    licenseKey: 'GPL',
    plugins: [Heading, Link, Bold, Table, TableToolbar, Italic, List, BlockQuote],
    language: this.locale.getCurrentLanguage(),
    toolbar: ['heading', '|', 'inserttable', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote'],
    heading: {
      options: [
        { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
        { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
        { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
        { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
        { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
        { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
      ]
    }
  };

  public data:any;

  public profile = {
    id: '',
  };


  public entity = {
    id: '',
    name: '',
    description: '',
    coverPhotoUri: '',
    avatarUri: ''
  }

  // Files
  avatarImageChangedEvent: any = '';
  avatarCroppedImage: any = '';
  avatarFileName =  '';

  coverImageChangedEvent: any = '';
  coverCroppedImage: any = '';
  coverFileName =  '';

  /**
   * Constructor
   *
   * @param activeModal
   */
  constructor(public activeModal: NgbActiveModal,
              private api: ApiService,
              private companyService: CompanyService,
              private locale: LocaleService,
              private alertService: AlertService) {


  }

  ngOnInit(): void {

    bsCustomFileInput.init();

    // Set data that is passed to modal
    this.profile = this.data.profile;
    this.entity = this.data.entity;

  }

  /**
   * Event handler when file input changes
   *
   * @param event
   */
  avatarFileChangeEvent(event: any): void {
    this.avatarImageChangedEvent = event;

    // Search for file name when input file changes
    if (this.avatarImageChangedEvent.target.files && this.avatarImageChangedEvent.target.files.length > 0) {

      for (let i = 0; i < this.avatarImageChangedEvent.target.files.length; i++) {
        const file = this.avatarImageChangedEvent.target.files[i];
        this.avatarFileName = file.name;
      }
    }
  }
  avatarImageCropped(event: ImageCroppedEvent) {
    this.avatarCroppedImage = event.base64;
  }
  avatarImageLoaded(image: HTMLImageElement) {
    // show cropper
  }
  avatarCropperReady() {
    // cropper ready
  }
  avatarLoadImageFailed() {
    // show message
  }



  /**
   * Event handler when file input changes
   *
   * @param event
   */
  coverFileChangeEvent(event: any): void {
    this.coverImageChangedEvent = event;

    // Search for file name when input file changes
    if (this.coverImageChangedEvent.target.files && this.coverImageChangedEvent.target.files.length > 0) {

      for (let i = 0; i < this.coverImageChangedEvent.target.files.length; i++) {
        const file = this.coverImageChangedEvent.target.files[i];
        this.coverFileName = file.name;
      }
    }
  }
  coverImageCropped(event: ImageCroppedEvent) {
    this.coverCroppedImage = event.base64;
  }
  coverImageLoaded(image: HTMLImageElement) {
    // show cropper
  }
  coverCropperReady() {
    // cropper ready
  }
  coverLoadImageFailed() {
    // show message
  }


  /**
   * Save
   * @constructor
   */
  Save() {

    // Update existing entry
    if (!empty(this.entity.id)) {

      this.companyService.apiUpdateTrademark(this.profile.id, this.entity.id, this.entity).pipe(catchError(this.companyService.handleError('apiUpdateTrademark', false))).subscribe( (result:any) => {

        const trademark_id = result['id'];

        // Upload possible files
        const fileUploadPromises = {
          avatarPromise : new Promise((resolve, reject) => {

            if (this.avatarCroppedImage && this.avatarFileName) {
              // Create multipart form data of base64 and upload to correct API endpoint

              fetch(this.avatarCroppedImage)
                .then(res => res.blob())
                .then(blob => {
                  const fd = new FormData();
                  const file = new File([blob], this.avatarFileName);
                  fd.append('file', file);

                  // Finally upload the file
                  const API_AVATAR_URL = this.api.getApiUrl() + '/company/' + this.profile.id + '/trademarks/' + trademark_id +  '/avatar';
                  const headers = this.api.getUploadHeaders();
                  fetch(API_AVATAR_URL, {method: 'PUT', headers: headers, body: fd})
                    .then((res) => {

                      if (res.status == 200) {
                        resolve(true);
                      } else {
                        // Some error
                      }

                    }).catch( (error) => {

                  })

                });

            }
            else {
              resolve(true);
            }

          }),
          coverPromise: new Promise( (resolve, reject) => {

            if (this.coverCroppedImage && this.coverFileName) {
              // Create multipart form data of base64 and upload to correct API endpoint

              fetch(this.coverCroppedImage)
                .then(res => res.blob())
                .then(blob => {
                  const fd = new FormData();
                  const file = new File([blob], this.coverFileName);
                  fd.append('file', file);

                  // Finally upload the file
                  const API_AVATAR_URL = this.api.getApiUrl() + '/company/' + this.profile.id + '/trademarks/' + trademark_id +  '/coverphoto';
                  const headers = this.api.getUploadHeaders();
                  fetch(API_AVATAR_URL, {method: 'PUT', headers: headers, body: fd})
                    .then((res) => {

                      if (res.status == 200) {
                        resolve(true);
                      } else {
                        // Some error
                      }

                    }).catch( (error) => {

                  })

                });

            }
            else {
              resolve(true);
            }

          })
        };

        // Wait for all promises to be resolved before auto closing modal
        Promise.all([fileUploadPromises.avatarPromise, fileUploadPromises.coverPromise]).then( (values) => {

          // Check values and then close or warn

          if (values[0] === true && values[1] === true) {
            this.alertService.success(alertMessages.successDataSaved);
            this.activeModal.close(true);
          } else {

          }

        });


      });

    }

    // Create new entry
    else {

      const { id, ...body } = this.entity;
      this.companyService.apiAddTrademark(this.profile.id, body).pipe(catchError(this.companyService.handleError('apiAddTrademark', false))).subscribe( (result:any) => {

        if (result !== false) {

          const trademark_id = result['id'];

          // Upload possible files
          const fileUploadPromises = {
            avatarPromise : new Promise((resolve, reject) => {

              if (this.avatarCroppedImage && this.avatarFileName) {
                // Create multipart form data of base64 and upload to correct API endpoint

                fetch(this.avatarCroppedImage)
                  .then(res => res.blob())
                  .then(blob => {
                    const fd = new FormData();
                    const file = new File([blob], this.avatarFileName);
                    fd.append('file', file);

                    // Finally upload the file
                    const API_AVATAR_URL = this.api.getApiUrl() + '/company/' + this.profile.id + '/trademarks/' + trademark_id +  '/avatar';
                    const headers = this.api.getUploadHeaders();
                    fetch(API_AVATAR_URL, {method: 'PUT', headers: headers, body: fd})
                      .then((res) => {

                        if (res.status == 200) {
                         resolve(true);
                        } else {
                          // Some error
                        }

                      }).catch( (error) => {

                    })

                  });

              }
              else {
                resolve(true);
              }

            }),
            coverPromise: new Promise( (resolve, reject) => {

              if (this.coverCroppedImage && this.coverFileName) {
                // Create multipart form data of base64 and upload to correct API endpoint

                fetch(this.coverCroppedImage)
                  .then(res => res.blob())
                  .then(blob => {
                    const fd = new FormData();
                    const file = new File([blob], this.coverFileName);
                    fd.append('file', file);

                    // Finally upload the file
                    const API_AVATAR_URL = this.api.getApiUrl() + '/company/' + this.profile.id + '/trademarks/' + trademark_id +  '/coverphoto';
                    const headers = this.api.getUploadHeaders();
                    fetch(API_AVATAR_URL, {method: 'PUT', headers: headers, body: fd})
                      .then((res) => {

                        if (res.status == 200) {
                          resolve(true);
                        } else {
                          // Some error
                        }

                      }).catch( (error) => {

                    })

                  });

              }
              else {
                resolve(true);
              }

            })
          };

          // Wait for all promises to be resolved before auto closing modal
          Promise.all([fileUploadPromises.avatarPromise, fileUploadPromises.coverPromise]).then( (values) => {

            // Check values and then close or warn

            if (values[0] === true && values[1] === true) {
              this.alertService.success(alertMessages.successDataSaved);
              this.activeModal.close(true);
            } else {

            }

          });

        }


      });

    }

  }

}
